import { MuiTheme, color, createStyles, makeStyles } from '@kis-technologies/kis-ui';

export const useStyles = (props?: { isOpen: boolean }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      deliverylogHeading: {
        padding: '24px 40px',
        justifyContent: 'space-between',
        background: 'transparent',
        display: 'flex',
        height: '100px',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
          flexDirection: 'column',
          height: 'auto'
        },
        [theme.breakpoints.only('sm')]: {
          alignItems: 'baseline',
          gap: '24px',
          padding: '24px 30px'
        },
        [theme.breakpoints.only('xs')]: {
          gap: '16px',
          justifyContent: 'center',
          padding: '16px 24px 0'
        }
      },
      deliverylogText: {
        fontSize: '40px',
        fontWeight: 600,
        lineHeight: '1',
        [theme.breakpoints.only('xs')]: {
          fontSize: '32px'
        }
      },
      deliverylogOptions: {
        padding: '0px 40px',
        background: 'transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        [theme.breakpoints.down('md')]: {
          flexDirection: 'column'
        },
        [theme.breakpoints.only('xs')]: {
          justifyContent: 'center',
          gap: '8px',
          padding: '0px 20px'
        }
      },
      filterOptions: {
        padding: '0px 40px',
        background: 'transparent',
        display: 'flex',
        height: '50px',
        alignItems: 'center'
      },
      deliverylogOuterBox: {
        flex: 1,
        minHeight: 0,
        background: 'transparent',
        padding: '0px 40px 0px',
        overflow: 'visible',
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.down('sm')]: {
          padding: '5px 20px 20px'
        }
      },
      deliveryTableContainer: {
        height: '400px',
        width: '500px'
      },
      deliverylogOrderOuterBox: {
        background: 'transparent',
        padding: '10px 20px 5px',
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem'
      },
      deliverylogTableBody: {
        '&:hover': {
          cursor: 'pointer'
        }
      },
      deliverylogHeaders: {
        padding: '16px 10px 16px 10px',
        lineHeight: '1.13',
        fontSize: '16px',
        cursor: 'pointer'
      },
      deliverylogTableRows: {
        padding: '16px 10px 16px 14px',
        height: '70px',
        '&$selected': {
          borderWidth: 0,
          borderLeftWidth: 20,
          borderColor: 'black',
          borderStyle: 'solid',
          backgroundColor: 'white'
        },
        '&$selected:hover': {
          backgroundColor: 'white'
        },
        '&$default': {
          backgroundColor: 'white'
        },
        '&$default:hover': {
          backgroundColor: 'white'
        }
      },
      selected: {},
      default: {},
      deliveryRefreshEventButton: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'end'
      },
      filtersFieldsFlexBox: {
        gap: '16px',
        [theme.breakpoints.down('md')]: {
          flexDirection: 'column',
          gap: 0
        }
      },
      filtersFieldBox: {
        height: '110px',
        minHeight: '110px'
      },
      filtersFieldLabel: {
        fontSize: '16px',
        fontWeight: 600,
        marginBottom: '10px',
        padding: '0 16px'
      },
      filtersInputField: {
        width: '262px',
        height: '45px',
        borderRadius: '50px',
        color: 'grey',
        '& .MuiOutlinedInput-notchedOutline': {
          borderWidth: '1px !important'
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: color.BLACK
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: color.BLACK
        }
      },
      datePickerContainer: {
        '& .react-datepicker-popper': {
          zIndex: 1500
        },
        '& .react-datepicker__close-icon': {
          padding: '0 12px 0 0'
        },
        '& .react-datepicker__close-icon::after': {
          backgroundColor: '#F46D2E'
        },
        '& .react-datepicker__day--selected': {
          backgroundColor: '#F46D2E',
          color: 'white'
        },
        '& .react-datepicker__day--today': {
          backgroundColor: '#F46D2E',
          color: 'white'
        },
        '& .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected':
          {
            backgroundColor: '#F46D2E',
            color: 'white'
          },
        '& .react-datepicker__today-button': {
          color: '#F46D2E'
        },
        '& .react-datepicker': {
          fontFamily: 'inherit'
        }
      },
      /* Shift left so the date picker is right aligned with the input field */
      rightDatePickerContainer: {
        '& .react-datepicker': {
          left: '-84px',
          [theme.breakpoints.down('md')]: {
            left: '0px'
          }
        }
      },
      datePickerInput: {
        fontSize: '16px',
        backgroundColor: 'white',
        border: 'solid 0.1em #cbd4c9',
        width: '262px',
        height: '45px',
        borderRadius: '50px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      },
      datePickerComponent: {
        width: '360px',
        height: '60px',
        borderRadius: '15px',
        padding: '12px'
      },
      '.my-datepicker-wrapper .react-datepicker-wrapper': {
        /* add your custom styles here */
        // border: '1px solid red'
      },
      filtersResetButtonBox: {
        justifyContent: 'flex-end',
        [theme.breakpoints.down('sm')]: {
          justifyContent: 'center'
        }
      },
      deliveryErrorSkeletonContainer: {
        display: 'flex',
        flex: '0 1 auto',
        flexDirection: 'column',
        background: 'transparent',
        overflow: 'hidden',
        gap: '16px'
      },
      inputRoot: {
        height: '45px',
        '& .MuiOutlinedInput-notchedOutline': {
          borderRadius: '30px'
        },
        '& .MuiOutlinedInput-input': {
          padding: '18px 30px'
        },
        '& .MuiInputLabel-outlined': {
          transform: 'translate(14px, 10px) scale(1)'
        },
        '& .MuiInputLabel-shrink': {
          transform: 'translate(14px, -6px) scale(0.75)'
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: 'grey'
        }
      },
      root: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        '& .MuiTextField-root': {
          // marginLeft: theme.spacing(2)
        },
        '& .MuiInputLabel-root': {
          position: 'relative',
          left: theme.spacing(-2),
          transform: 'none'
        }
      },
      searchField: {
        marginRight: theme.spacing(1),
        width: '524px',
        [theme.breakpoints.down('sm')]: {
          width: '262px'
        }
      },
      exportToCsvButton: {
        display: 'flex',
        width: '100%',
        justifyContent: 'end'
      },
      buttonsWarpStyle: {
        display: 'flex',
        width: '100%',
        gap: '1.5rem',
        [theme.breakpoints.only('sm')]: {
          margin: '12px 0 0',
          justifyContent: 'center'
        },
        [theme.breakpoints.only('xs')]: {
          margin: '12px 0 0',
          justifyContent: 'center',
          height: '100%',
          gap: '8px',
          padding: '0px'
        }
      },
      filtersButton: {
        marginLeft: '40px',
        [theme.breakpoints.down('md')]: {
          marginLeft: '0px'
        }
      },
      buttonStyl: {
        '&.MuiChip-outlined .MuiChip-deleteIcon': {
          color: 'white'
        }
      },
      formLabel: {
        margin: '0px 0px 10px',
        fontSize: '16px',
        fontWeight: 'bold',
        paddingLeft: '16px'
      },
      formBox: {
        background: 'transparent',
        minWidth: '100%',
        [theme.breakpoints.down('xs')]: {
          height: '110px'
        },
        '& > * > *': {
          [theme.breakpoints.down('xs')]: {
            minWidth: '240px',
            width: '245px'
          }
        }
      },
      footer: {
        width: '100%',
        overflow: 'hidden',
        padding: '0px 40px'
      },
      total: {
        float: 'right',
        margin: 0,
        fontSize: '20px',
        padding: '24px 0 0',
        fontWeight: 900
      },
      body: {
        overflow: props && props.isOpen ? 'hidden' : 'auto'
      }
    })
  );
